<template>
    <div class="checkin-shop-login-staff">
        <div class="box">
            <img class="box__logo" src="/images/logo-1.png" alt="">
            <h1 class="box__title">{{ shop.name }}</h1>
            <div class="btn-line-login" @click="goLine">
                <img class="btn-line-login__img" src="/images/icon_line.png" alt="">
                <div class="btn-line-login__divide"></div>
                <div class="btn-line-login__text">
                    {{ $t('login_line_title') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        shop: { type: Object, required: false },
    },
    data() {
        return {};
    },
    methods: {
        goLine() {
            window.open(this.$lineUrl + '?type=checkin', '_blank')
        },
    },
}
</script>

<style lang="scss" scoped>
.checkin-shop-login-staff {
    background: #FFFCF9;
    .box {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        .box__logo {
            width: 137px;
            height: 90px;
        }
        .box__title {
            font-size: 17px;
            letter-spacing: 1.7px;
            padding: 55px 0 40px;
            margin: 0;
        }
    }
}
.btn-line-login {
    background: #06C755;
    width: 280px;
    height: 60px;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;

    .btn-line-login__img {
        width: 39px;
        height: 37px;
        object-fit: contain;
    }

    .btn-line-login__divide {
        height: 100%;
        width: 1px;
        background: rgb(0, 0, 0, 0.08);
        margin-left: 20px;
    }

    .btn-line-login__text {
        margin-left: 25px;
        font-size: 14px;
        color: #fff;
        letter-spacing: 1.4px;
        line-height: 31px;
    }
}
</style>
